import { useQuery } from "@tanstack/react-query";
import ProductAPI from "../api/Product";

export default function useProductManager() {
  const keys = {
    getAll: "get-all-products",
    get: "get-product-by-id",
    suggestFromId: "get-suggest-products-by-id",
  };

  function getAllProducts(params?: any) {
    return useQuery({
      queryKey: [keys.getAll, params],
      queryFn: (context) => ProductAPI.getProducts(context, params),
    });
  }

  function get(id: string) {
    return useQuery({
      queryKey: [keys.get, id],
      queryFn: (context) => ProductAPI.getProductById(context, id),
      retry: 0,
    });
  }

  function getSuggestProductFromId(id: string) {
    return useQuery({
      queryKey: [keys.suggestFromId, id],
      queryFn: (context) => ProductAPI.getSuggestProductsById(context, id),
    });
  }

  return { keys, getAllProducts, get, getSuggestProductFromId };
}
